<template>
  <div class="flex">
    <div v-if="selectPerPage" class="flex items-center">
      <span class="mr-2 whitespace-pre">{{ $t('labels.per_page') }}:</span>
      <div class="z-500 w-20">
        <base-multiselect
          :value="pagination.per_page"
          :options="paginationOptions"
          @input="$emit('selectedPerPage', $event)"
          selectedLabel=""
          selectLabel=""
          deselectLabel=""
          class="-mt-4"
          :allow-empty="false"/>
      </div>
    </div>
    <vs-pagination :max="max" :total="pagination.total_pages" @input="pageChange" class="mt-2"
                   v-model="value"></vs-pagination>
  </div>
</template>

<script>
  export default {
    name:'Pagination',
    props:{
      pagination:{
        type:Object,
        required:true
      },
      max:{
        type:Number,
        default:7
      },
      selectPerPage: {
        type:Boolean,
        default:false
      }
    },
    data:() => ({
      paginationOptions:[5, 10, 15, 20, 30, 50, 100],
      value:null
    }),
    methods:{
      pageChange(val) {
        this.$emit('input', val)
      }
    },
    created() {
      this.value = this.pagination.current_page
    }
  }
</script>

<style scoped>

</style>
